import React, { useEffect, useState } from "react";
import api from "APP_ROOT/api";
import { get, flatten } from "lodash";
import T from "prop-types";
import { STATE } from "APP_ROOT/constants";
import { toSentence } from "LIB/formatters/text";
import Warning from "../../../shared/components/Warning/Warning";

export default function RestrictedAddressWarning({
  line1,
  city,
  state,
  postal_code: postalCode,
  country,
  requireApproval
}) {
  const addressParams = {
    line1,
    city,
    state,
    postal_code: postalCode,
    country
  };

  if (
    Object.entries(addressParams)
      .filter(([key]) => key !== STATE)
      .some(([_, value]) => !value)
  )
    return null;

  const [restrictedAddresses, setRestrictedAddresses] = useState(null);

  useEffect(
    () => {
      api.restrictedEntities.addressSearch(addressParams).then(resp => {
        if (Number(get(resp, "data.total", 0)) > 0) {
          setRestrictedAddresses(resp.data.results);
        } else {
          setRestrictedAddresses(null);
        }
      });
    },
    [line1, city, state, postalCode, country]
  );

  if (!restrictedAddresses) return null;

  return (
    <Warning>
      Warning: Similar entity address in US Gov&apos;t Screening List: ${toSentence(
        flatten(restrictedAddresses.map(r => r.individual_address))
      )}{" "}
      {requireApproval && "Preapproval Required."}
    </Warning>
  );
}

RestrictedAddressWarning.propTypes = {
  line1: T.string,
  city: T.string,
  state: T.string,
  postal_code: T.string,
  country: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/RestictedAddressWarning/RestrictedAddressWarning.jsx